import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';
import delivery_logo from '../assets/delivery_logo.png';
import flavchap_delivery_logo from '../assets/flavchap_delivery_logo.png';
import delivery_partner_logo from '../assets/delivery_partner_logo.png'
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

const DeliveryPartnerHeader = () => {
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      dispatch(logout());
      await logoutApiCall().unwrap();
      
      await signOut(auth);

      localStorage.clear();
      window.location.href = '/deliverypartner/login';
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <header>
      <Navbar bg='dark' variant='dark' className='py3 flavchap-delivery-header'>
        <Container className="d-flex flex-column align-items-center gap-3">
          <div className='d-flex flex-wrap justify-content-center align-items-center gap-3 w-100'>
            <Link to='/deliverypartner'>
              <Navbar.Brand className="text-center">
                <img src={flavchap_delivery_logo} className="img-fluid flavchap-logo" alt='Flavchap Logo'/>
                <img src={delivery_logo} className="img-fluid logo mx-2" alt='Telugu Pindi Vantalu Logo'/>
                <img src={delivery_partner_logo} className="img-fluid delivery-partner-logo" alt='Delivery Partner Logo'/>
              </Navbar.Brand>
            </Link>
          </div>
          <Nav className='d-flex flex-wrap justify-content-center gap-3 w-100'>
            {userInfo ? (
              <NavDropdown title={userInfo.name} id='username'>
                <NavDropdown.Item as={Link} to='/deliverypartner'>
                  Deliveries
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to='/deliverypartner/documents'>
                  Documents
                </NavDropdown.Item>
                <NavDropdown.Item onClick={logoutHandler}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link as={Link} to='/deliverypartner/login' onClick={(e) => {
                e.preventDefault();
                window.location.href = '/deliverypartner/login'; // force full reset
              }}>
                <FaUser/> Sign In
              </Nav.Link>
            )}
          </Nav>
        </Container>
      </Navbar>
    </header>
  )
}

export default DeliveryPartnerHeader